<template>
  <!-- 関連OKR1 -->
  <div>
    <!-- <div class="flex-box">
      <span class="info-userimg">
        <img v-if="getUsers[getUserId].userInfo.userIcon" :src="getUsers[getUserId].userInfo.userIcon" alt="image" class="img-circle">
        <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
      </span>
    </div> -->
    <div class="relation-object cursor" @click="onClickDetail" v-bind:class="{isDeletedUser: getMetaIsDeleted(getTargetUserId)}">
      <span class="info-userimg">
        <img v-if="getUserInfoById(getTargetUserId).userIcon" :src="getUserInfoById(getTargetUserId).userIcon" alt="image" class="img-circle">
        <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
      </span>
      <span class="relation-object-text">
        <span class="info-username">{{ getUserInfoById(getTargetUserId).userName }}</span>
        <read-more :text="this.getItem(getItemId, getTargetUserId, getType).contentText" :addMore="false" :showMore="this.propShowMore" :targetId="this.getItemId" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight">
          {{ this.getItem(getItemId, getTargetUserId, getType).contentText }}
        </read-more>
      </span>
      <objective-knob :progress="this.getRate" :readOnly="true" :width="55" :height="55"></objective-knob>
    </div>
    <div class="ibox-tools">
      <span class="info-menu"></span>
      <span class="info-right">
          <span class="info-comment-detail">
              <img src="static/img/assets/comment.png">
              <span>{{getCommentsByItemId(getItemId, getType).length}}</span>
          </span>
          <span class="info-comment-detail date-color">{{$t('startDateStr')}} : {{this.getItem(getItemId, getTargetUserId, getType).startDate}}</span>
          <span class="info-comment-detail date-color">{{$t('dueDateStr')}} : {{this.getItem(getItemId, getTargetUserId, getType).dueDate}}</span>
          <!-- <okr-drop-down v-if="this.getUserId === this.getTargetUserId" :tag="'removeRelation'" :item="getItem(getItemId, getTargetUserId, getType)" :id="getItemId" v-on:remove-relation="removeRelationItem"/> -->
          <okr-drop-down v-if="false" :tag="'removeRelation'" :item="getItem(getItemId, getTargetUserId, getType)" :id="getItemId" v-on:remove-relation="removeRelationItem"/>
      </span>
    </div>
  </div>
  <!-- /関連OKR1  -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ObjectiveKnob from '@/components/Okr/ObjectiveKnob'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import OkrDropDown from '@/components/Okr/OkrDropDown'

export default {
  name: 'RelationItem',
  props: {
    itemId: String,
    userId: String,
    type: String,
    relationKey: String,
    parentKey: String,
    parentType: String,
    parentUserId: String,
    isRelationViewOpen: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ObjectiveKnob,
    ReadMore,
    OkrDropDown
  },
  data () {
    return {
      items: {
        itemId: '',
        userId: '',
        type: ''
      },
      propContentHeight: 0,
      propShowMore: false
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentUserInfo',
      'getUserId'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresultById'
    ]),
    ...mapGetters('objectives/', [
      'getObjectiveById',
      'getCurrentObjectives'
    ]),
    ...mapGetters('comments/', [
      'getCommentsByItemId'
    ]),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    getItemId: function () {
      return this.itemId
    },
    getTargetUserId: function () {
      return this.userId
    },
    getType: function () {
      return this.type
    },
    getRate: function () {
      return this.getItem(this.getItemId, this.getTargetUserId, this.getType).progress ? Number(this.getItem(this.getItemId, this.getTargetUserId, this.getType).progress) : 0
    }
  },
  methods: {
    ...mapActions('okrs/', {
      'removeRelation': 'REMOVE_RELATION'
    }),
    getItem: function (itemId, userId, type) {
      if (type === 'objectives') {
        return this.getObjectiveById(itemId, userId)
      } else if (type === 'keyresults') {
        return this.getKeyresultById(itemId, userId)
      }
    },
    onClickDetail: function () {
      let items = {
        itemId: this.getItemId,
        userId: this.getTargetUserId,
        type: this.getType
      }
      // this.items.itemId = this.getItemId
      // this.items.userId = this.getTargetUserId
      // this.items.type = this.getType
      console.log(items)
      this.$emit('get-detail', items)
      // this.$emit('get-detail', value)
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    },
    removeRelationItem: function () {
      const value = {
        type: this.parentType,
        key: this.parentKey,
        relationKey: this.relationKey
      }
      this.$swal({
        title: this.$t('popTitleStrType'),
        text: this.$t('doDeleteStr'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 3000
      }).then((result) => {
        if (result.value) {
          this.removeRelation(value).then(
            this.$swal({
              title: this.$t('compDeleteStr'),
              type: 'success',
              animation: false,
              customClass: 'animated fadeInUp',
              // customClass: 'animated flipInX',
              width: '35rem',
              position: 'center',
              // toast: true,
              padding: '2rem',
              timer: 3000
            })
          )
          console.log('confirmDeletePictureStr -> true')
        } else {
          console.log('confirmDeletePictureStr -> false')
        }
      })
    }
  },
  updated: function () {
    console.log('hoge', this.itemId, this.userId, this.type)
  }
}
</script>
<style scoped>
  .OkrProgress{
      position: absolute;
      width: 8rem;
  }
  .isDeletedUser {
    cursor: default
  }
</style>



// WEBPACK FOOTER //
// src/components/Okr/RelationItem.vue